import React, { useState, useEffect } from 'react'
import './css/style.css';
import Layouts from './layouts/layout';
import { NavLink, useNavigate  } from 'react-router-dom';
import { getProfile,getSubStatus } from '../services/home';
import { useTranslation } from 'react-i18next';
import { PopupSub } from '../utils/constant';

const Profile = () => {
    let navigate = useNavigate(); 
    const [popup, setPopup] = useState(false);
    const [subStatus, setSubStatus] = useState(0);

    const onLogout = () => {
        localStorage.clear();
        window.location.href = "/"
    }
    const [profile, setProfile] = useState([]);
    const { t } = useTranslation();
    useEffect(() => {
      const fetchData = async () => {
        try {
          const res = await getProfile();
          setProfile(res);
          localStorage.setItem('oldPack',res?res.packId:1);
        } catch (err) {
          console.error(err);
        }
      };
  
      fetchData();
    }, []);

     const upgrade = async () => {  
        if(profile && profile.packId>=3) {setSubStatus(139);setPopup(true);}
        else navigate('/upgrade');
    }
    const redirectToPage = (page) => {
        navigate(page);
    }    
     const redirectTo = async (input) => {
        if(input && input.length>2)navigate(input);
        else {setSubStatus(0);setPopup(false);}
    }
    const dummyImage = '/image/image 4.png';
  return (
    <Layouts>
    <div className='home'> 
      <div className="maine-div">
          <div className="container box-wrapper">
              <div className="header">
                  <div className="row align-items-center">
                      <div className="col-6 text-start">
                          <div className="logo d-flex">
                              <a href="#">
                                <img src="/image/Logo_new.png" alt="Logo" />
                              </a>
                              {/* <span className='logo-name'>CaliQuiz</span> */}
                          </div>
                      </div> 
                      {/* <div className="col-6 text-end">
                          <a href="#" className="search" id="btnSearch">
                          <img src="/image/search.png" alt="Logo" />
                          </a>
                      </div>  */}
                  </div>
              </div>
              <div className="home-profile">
                  <div className="row gx-0">
                      <div className="col-7 text-start">
                          <div className="d-flex align-items-center">
                              <div className="avatar"> 
                                <img src={profile?.image || dummyImage} alt="Avatar" className="Avatar" />
                              </div>
                              <div className="flex-grow-1 ms-2">
                                  <div className="profile-info"> 
                                  <h4 className="profile-name">{profile?.name} </h4>
                                  <p> {profile?.mobileNumber}</p>
                                  
                                  </div>
                                      {/* <div className="home-profile-status">Guest</div> */} 
                                  </div>
                              </div>
                      </div>
                      <div className="col-5 text-end">
                          <div className="h-100 d-flex align-items-center justify-content-end">
                              <span className="profile-subscriber"> {t('7')} </span>
                          </div>
                      </div>
                       
                       <div className="col-12 text-start">
                         {/* <p className="profile-unsubscribe">{t('8')}</p> */}
                         <button className="pack-btn btn btn-primary btn-pm-custom"
                           onClick={() => {redirectToPage('/unsub')}}>{t("8")}</button>
                      </div>

                      <div className="col-12 text-start">
                         <button className="pack-btn btn btn-primary btn-pm-custom"
                           onClick={upgrade} >{t("137")}</button>
                      </div>

                     

                  </div>
              </div>
              
              <div className="content-box">
                 
              <ul className="profile-list-wrapper">
              <li className="profile-list" onClick={() => {redirectToPage('/redeem')}}>
                    <NavLink to="/redeem" className="d-flex w-100">
                        <div className="profile-list-pict">
                            <img src="/image/money.png" alt="History" className="game-icon" /> 
                        </div>
                        <div className="profile-list-info">
                            <h4 className="profile-list-info-title">{t('140')}</h4>
                        </div>
                    </NavLink>
                </li>

              <li className="profile-list" onClick={() => {redirectToPage('/history')}}>
                    <NavLink to="/history" className="d-flex w-100">
                        <div className="profile-list-pict">
                            <img src="/image/controller.png" alt="History" className="game-icon" /> 
                        </div>
                        <div className="profile-list-info">
                            <h4 className="profile-list-info-title">{t('9')}</h4>
                        </div>
                    </NavLink>
                </li>

                <li className="profile-list" onClick={() => {redirectToPage('/edit')}}>
                    <NavLink to="/edit" className="d-flex w-100">
                        <div className="profile-list-pict">
                            <img src="/image/Setting_group.png" alt="Edit Profile" /> 
                        </div>
                        <div className="profile-list-info">
                            <h4 className="profile-list-info-title">{t('10')}</h4>
                        </div>
                    </NavLink>
                </li>
                
                <li className="profile-list" onClick={() => {redirectToPage('/language')}}>
                    <NavLink to="/language" className="d-flex w-100">
                        <div className="profile-list-pict">
                            <img src="/image/language.png" alt="Languages" /> 
                        </div>
                        <div className="profile-list-info">
                            <h4 className="profile-list-info-title">{t('11')}</h4>
                        </div>
                    </NavLink>
                </li> 
                <li className="profile-list" onClick={() => {redirectToPage('/policy')}}>
                      <NavLink to="/policy" className="d-flex w-100">
                        <div className="profile-list-pict">
                            <img src="/image/note.png" alt="note" /> 
                        </div>
                        <div className="profile-list-info">
                            <h4 className="profile-list-info-title">{t('93')}</h4>
                        </div>
                    </NavLink>
                </li>
                <li className="profile-list" onClick={() => {redirectToPage('/terms')}}>
                      <NavLink to="/policy" className="d-flex w-100">
                        <div className="profile-list-pict">
                            <img src="/image/note.png" alt="note" /> 
                        </div>
                        <div className="profile-list-info">
                            <h4 className="profile-list-info-title">{t('92')}</h4>
                        </div>
                    </NavLink>
                </li>

                <li className="profile-list" onClick={() => {redirectToPage('/faq')}}>
                      <NavLink to="/policy" className="d-flex w-100">
                        <div className="profile-list-pict">
                            <img src="/image/note.png" alt="note" /> 
                        </div>
                        <div className="profile-list-info">
                            <h4 className="profile-list-info-title">{t('91')}</h4>
                        </div>
                    </NavLink>
                </li>

                <li className="profile-list" onClick={() => {redirectToPage('/contactus')}}>
                      <NavLink to="/contactus" className="d-flex w-100">
                        <div className="profile-list-pict">
                            <img src="/image/support.png" alt="support" /> 
                        </div>
                        <div className="profile-list-info">
                            <h4 className="profile-list-info-title">{t('13')}</h4>
                        </div>
                    </NavLink>
                </li>
                <li className="profile-list" onClick={onLogout}>
                      <NavLink to="#" className="d-flex w-100" >
                        <div className="profile-list-pict">
                            <img src="/image/logout.png" alt="logout" /> 
                        </div>
                        <div className="profile-list-info">
                            <h4 className="profile-list-info-title">{t('14')}</h4>
                        </div>
                    </NavLink>
                </li>
               </ul>                 
            </div>
          </div>
      </div> 
    </div>
    {popup && <PopupSub redirectTo={redirectTo} subStatus={subStatus} />}
    </Layouts>
  )
}

export default Profile